module.exports = __webpack_public_path__ + "img/clean.7eb62e2a.png";